import { faExpand, faExpandArrowsAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dialog } from "@headlessui/react";
import { IKImage } from "imagekitio-react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { createSkillCertificate, getCertificate, getCertificateLink, getSkillCertificateLink } from "../../../redux/actions/certificate";
import { getMskillProgress, getSkillProgress } from "../../../redux/actions/contentPayer";
import { getLinkFromBuffer } from "../../../utils/generateCertificate";
import ProgressBar from "../Quiz/ProgressBar";
import Spinner from "../../../components/Spinner";
import './index.css'

const CertificatePreview = ({isModalEnabled , setIsModalEnabled ,mskillProgressObject , skillProgress}) => {
  const dispatch = useDispatch();
  const user_id = useSelector(store=>store?.profileDetails?.id);
  const [certificateLink , setCertificateLink] = useState("");
  const [skillCertificateLink , setSkillCertificateLink]= useState("");
  const {  mskill_slug , skill_slug} = useParams();
  const [isSkillPreview , setIsSkillPreview] = useState(false);
  const duration = useSelector(store => store?.userActivity?.last_mskill_duration);
  const is_activation = useSelector(store => store?.userActivity?.is_activation)
 

  useEffect(()=>{

    dispatch(
      getCertificate(user_id, mskill_slug, async (data) => {
        dispatch(
          getCertificateLink(
            data?.unique_certificate_id,
            "image_png",
            (link) => {
              
           
              setCertificateLink(link)
              console.log(link);
            
            }
          )
        );
      })
    );

    dispatch(
      createSkillCertificate(user_id, skill_slug, (successObj) => {
      

        dispatch(
          getSkillCertificateLink(
            successObj?.unique_certificate_id,
            "image_png",
            (link) => {
              setSkillCertificateLink(link);
              console.log(link);
            }
          )
        );
      })
    );

    

  },[])
 
  return (
    <>
      <Dialog
        open={isModalEnabled}
        onClose={() => setIsModalEnabled(false)}
        as="div"
        style={{ zIndex: "10" }}
        className="fixed inset-0 z-10 -mt-10 flex flex-col items-center justify-center overflow-y-auto md:mt-10 md:justify-start"
      >
        <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
        <Dialog.Title />
        <Dialog.Description />
        { (certificateLink?.length>0 && skillCertificateLink?.length > 0) ? <div className="relative z-10 flex  w-11/12 flex-col border-4 border-[#FEC431] justify-center items-center overflow-auto rounded-xl bg-white py-4 px-4 shadow-2xl  md:w-1/4 md:p-4 lg:w-1/4">

        <div className="font-bold text-xl">Upcoming certificates</div> 
        <div className="font-medium text-md mt-2 self-start">Current Micro-Skill Certificate:</div>
        <div className="relative flex flex-col items-center justify-center mt-1">
            <img
              src={certificateLink}
              alt="certificate link"
              className="w-full rounded-lg"
            />
            <div className="flex justify-center items-center absolute top-0 right-0 rounded-tr-lg rounded-bl-lg px-2 py-1 certificatePreview-background-gradient" >
              <img
                urlEndpoint="https://assets.learntube.ai/files/"
                src={
                  "https://assets.learntube.ai/files/PRICING/img28.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1662191682870"
                }
                className="w-4"
              />
              <div className="text-xs text-white ml-1">Premium feature</div>
            </div>
            
            <img
              urlEndpoint="https://assets.learntube.ai/files/"
              src={
                "https://assets.learntube.ai/files/Content_player/Group_7272.svg?updatedAt=1679056840095"
              }
              className="absolute bottom-0 w-full"
            />
          </div>
          {mskillProgressObject?.progress_by_completed?.progress !== 100 && (
              <div className="mt-2 flex  w-full items-center justify-start ">
                <div className="w-1/5 px-2">
                  <ProgressBar
                    bgcolor={"#54D15A"}
                    progress={mskillProgressObject?.progress_by_completed?.progress}
                    height={10}
                  />
                </div>
                <div className="md:text-md ml-2 whitespace-nowrap text-xs font-medium">
                  {mskillProgressObject?.progress_by_completed?.totalLessons - mskillProgressObject?.progress_by_completed?.completedLessons} lessons left to get this certificate
                </div>
              </div>
            )}
          <div className="flex self-start  justify-start items-center mt-1 px-2">
          
              <img
                  urlEndpoint="https://assets.learntube.ai/files/"
                  src={"https://assets.learntube.ai/files/Content_player/clock_2.svg?updatedAt=1679573545239"}
                  transformation={[{
                      "height": "110",
                      "width": "110",
                  }]}
                  className="h-5 w-5 mr-1"
              />
              
          
            <div className="text-xs whitespace-nowrap">Most users complete this micro-skill in <span className="font-bold">{Math.min(Math.floor(duration/60) , 120)} minutes</span></div>
          </div>
          <div className="flex flex-col justify-center items-center mt-4 border-2 px-2 py-2">
              <div className="font-medium text-md self-start">Final Skill Certificate:</div>
              <div className="text-[#53B399] text-xs self-start">Surveying Data Through Card Sorting and Site Maps</div>
        
          <div className="flex justify-center items-center mt-2">
            <div className="relative w-full">
              <img src={skillCertificateLink} alt="skill certificate link" className="w-28 h-20 mb-1"></img>
              <FontAwesomeIcon
                  icon={faExpandArrowsAlt}
                  size="md"
                  className="text-white absolute top-1 right-1 cursor-pointer"
                  onClick={(e)=>setIsSkillPreview(true)}
                />
              {!is_activation && <ProgressBar
                bgcolor={"#54D15A"}
                progress={Math.max(20, skillProgress)}
                height={8}
              />}
            </div>
            <div className="text-xs text-start ml-4">Complete <span className="font-bold">all micro-skills</span> to unlock. This certificate can increase your chance of getting hired by <span className="font-bold">67%</span></div>
          </div>
          </div>
          <button className='bg-[#13B284] w-auto mt-4 text-white px-4 py-2 rounded-lg' onClick={(e)=> setIsModalEnabled(false)}>Keep Learning</button>
        </div> : <Spinner/>}
      </Dialog>
      {
        isSkillPreview && 
        <Dialog
        open={isSkillPreview}
        onClose={() => setIsSkillPreview(false)}
        as="div"
        style={{ zIndex: "9999999999" }}
        className="fixed inset-0 z-[9999999999] -mt-10 flex flex-col items-center justify-center overflow-y-auto md:mt-40 md:justify-start"
      >
        <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
        <Dialog.Title />
        <Dialog.Description />
        <div className="relative z-[9999999999] flex  w-11/12 flex-col border-4 border-[#FEC431] justify-center items-center overflow-auto rounded-xl bg-white  shadow-2xl  md:w-1/4 md:p-4 lg:w-1/4">

          
         
          
              <img src={skillCertificateLink} alt="skill certificate link" className="w-full"></img>
        
        </div>
      </Dialog>
      }
    </>
  );
};

export default CertificatePreview;
